import momentLocalTimezone from 'src/utils/momentLocalTimezone';

const makeInitialState = data => {
  return {
    motive: data.motive,
    invoiceType: data.invoiceType,
    category: data.category,
    contractId: data.contractId,
    clientId: data.clientId,
    clientName: data.clientName,
    folio: data.folio,
    amount: data?.amount || 0,
    comment: data?.comment || '',
    paymentForm: data?.paymentForm || undefined,
    paymentDate: data?.paymentDate
      ? momentLocalTimezone(data.paymentDate)
      : momentLocalTimezone(),
    relatedDocuments: data?.relatedDocuments || [],
    date: momentLocalTimezone()
  };
};

export default makeInitialState;
